/* eslint-disable */
// Do not edit this file manually. It's auto generated by: scripts/gen-apiclients.ts

import {
  ApiApi,
  ApiConfig,
  HttpClient,
  HttpResponse,
} from './api.smartthings.com.v1';
import { BestowApi } from './bestow.st.internal.v20210915';
import { BorgApi } from './borg.st.internal.v20210521';
import { ClientV1Api } from './client.smartthings.com.v1';
import { ClientV2Api } from './client.smartthings.com.v2';
import { ClientV3Api } from './client.smartthings.com.v3';
import { ClientV4Api } from './client.smartthings.com.v4';
import { ClientV5Api } from './client.smartthings.com.v5';
import { ClientV6Api } from './client.smartthings.com.v6';
import { GizmoApi } from './gizmo.st.internal.v20170916';
import { HedgeApi } from './hedge.v1';
import { PastoraApi } from './pastora.st.internal.v20210608';
import { ReplicatorApi } from './replicator.stinternal.net.v20220202';
import { SiamApi } from './siam.st.internal.v20211004';

export { ApiApi } from './api.smartthings.com.v1';
export { BestowApi } from './bestow.st.internal.v20210915';
export { BorgApi } from './borg.st.internal.v20210521';
export { ClientV1Api } from './client.smartthings.com.v1';
export { ClientV2Api } from './client.smartthings.com.v2';
export { ClientV3Api } from './client.smartthings.com.v3';
export { ClientV4Api } from './client.smartthings.com.v4';
export { ClientV5Api } from './client.smartthings.com.v5';
export { ClientV6Api } from './client.smartthings.com.v6';
export { GizmoApi } from './gizmo.st.internal.v20170916';
export { HedgeApi } from './hedge.v1';
export { PastoraApi } from './pastora.st.internal.v20210608';
export { ReplicatorApi } from './replicator.stinternal.net.v20220202';
export { SiamApi } from './siam.st.internal.v20211004';

// Use the first api interface and class to create the common API clients' Typed definitions
export interface TypedApiConfig<T, SecurityDataType = unknown>
  extends ApiConfig<SecurityDataType> {
  apiType: ApiType & (new (config?: ApiConfig<SecurityDataType>) => T);
}

export class TypedHttpClient<
  SecurityDataType extends unknown = unknown,
> extends HttpClient<SecurityDataType> {
  public apiKey?: ApiKeyType | undefined;
}

export interface TypedHttpResponse<T = unknown, E = unknown>
  extends HttpResponse<T, E> {}

export type ApiType =
  | typeof TypedHttpClient
  | typeof ApiApi
  | typeof BestowApi
  | typeof BorgApi
  | typeof ClientV1Api
  | typeof ClientV2Api
  | typeof ClientV3Api
  | typeof ClientV4Api
  | typeof ClientV5Api
  | typeof ClientV6Api
  | typeof GizmoApi
  | typeof HedgeApi
  | typeof PastoraApi
  | typeof ReplicatorApi
  | typeof SiamApi;

export const ApiMeta = {
  api: { api: ApiApi, version: '1', key: 'api' },
  bestow: { api: BestowApi, version: '20210915', key: 'bestow' },
  borg: { api: BorgApi, version: '20210521', key: 'borg' },
  clientv1: { api: ClientV1Api, version: '1', key: 'clientv1' },
  clientv2: { api: ClientV2Api, version: '2', key: 'clientv2' },
  clientv3: { api: ClientV3Api, version: '3', key: 'clientv3' },
  clientv4: { api: ClientV4Api, version: '4', key: 'clientv4' },
  clientv5: { api: ClientV5Api, version: '5', key: 'clientv5' },
  clientv6: { api: ClientV6Api, version: '6', key: 'clientv6' },
  gizmo: { api: GizmoApi, version: '20170916', key: 'gizmo' },
  hedge: { api: HedgeApi, version: '1', key: 'hedge' },
  pastora: { api: PastoraApi, version: '20210608', key: 'pastora' },
  replicator: { api: ReplicatorApi, version: '20220202', key: 'replicator' },
  siam: { api: SiamApi, version: '20211004', key: 'siam' },
};

export type ApiMetaType = typeof ApiMeta;

export type ApiKeyType = keyof ApiMetaType;

export type ApiKey = { apiKey?: ApiKeyType };

/// End of APIs indexes ///
